export default function FormSection({
  children,
  title,
  description,
  className,
}) {
  return (
    <div
      className={classnames(
        'flex w-full gap-10 flex-col md:flex-row',
        className,
      )}>
      <div className="flex-shrink-0 md:w-80">
        <div className="mb-2 text-base font-semibold">{title}</div>
        <div className="text-sm">{description}</div>
      </div>
      <div className="flex-grow h-full">{children}</div>
    </div>
  );
}
